import * as React from 'react'

import { connect } from 'react-redux'

import * as mixpanel from 'mixpanel-browser'
import { MixpanelProvider } from 'react-mixpanel'

import { get } from 'lodash'

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '')

export const withMixpanelProvider = (Component: React.ElementType) => {
  interface IReduxStateProps {
    user: any
  }

  interface IReduxDispatchProps {}

  type IProps = IReduxStateProps & IReduxDispatchProps

  class WithMixpanel extends React.Component<IProps> {
    componentDidMount() {
      const { user } = this.props
      if (user) {
        mixpanel.identify(get(user, ['auth', 'uid']))
      }
    }

    render() {
      return (
        <MixpanelProvider mixpanel={mixpanel}>
          <Component {...this.props} />
        </MixpanelProvider>
      )
    }
  }

  const mapStateToProps = (state): IReduxStateProps => ({ user: state.user })
  const mapDispatchToProps = (dispatch): IReduxDispatchProps => ({})

  const Connected = connect(mapStateToProps, mapDispatchToProps)(WithMixpanel)

  return props => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/MixPanel/withMixpanelProvider.tsx